import { PocHeader } from 'commons/components/components-wrapper/poc-header.component';
import styled from 'styled-components';

export const PocHeaderStyled = styled(PocHeader)`
    position: relative;
    z-index: var(--one-z-index-header);

    owc-header-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
`;

export const HeaderOptions = styled.div`
    display: flex;
    align-items: center;
`;

export const SettingsOptions = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 0 10px;
`;

export const UserOptions = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 0 10px;
`;
